import { motion } from "framer-motion";
import { CHAPTERS } from "@/lib/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Story() {
  return (
    <section id="story" className="relative z-10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 max-w-2xl"
        >
          <p className="font-body text-sm uppercase tracking-[0.25em] text-gold">The Story</p>
          <h2 className="mt-3 font-display text-4xl font-bold leading-tight text-cream md:text-5xl">
            A summer that awakened her heart
          </h2>
        </motion.div>

        <div className="flex flex-col gap-16 md:gap-24">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className={`relative grid grid-cols-1 items-center gap-6 md:grid-cols-12 ${
                i % 2 === 1 ? "md:text-right" : ""
              }`}
              data-testid={`story-chapter-${c.n}`}
            >
              <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2 md:col-start-8" : ""}`}>
                <span className="font-display text-7xl font-black text-gold/20 md:text-9xl">{c.n}</span>
              </div>
              <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-1 md:col-start-1 md:row-start-1" : ""}`}>
                <h3 className="font-display text-2xl font-semibold text-cream md:text-3xl">{c.title}</h3>
                <p className="mt-4 font-body text-lg leading-relaxed text-slate-300">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
